export class TopHeader {
    constructor() {
      this._topHeader = document.querySelector('.h-top')
      this._topHeaderNav = document.querySelector('.h-top-nav')
      this._itemsWithChildren = document.querySelectorAll('.h-top .menu-item-has-children')

      if (!this._topHeader || !this._topHeaderNav || !this._itemsWithChildren.length) return

      this._active = null
      this._closeTimeout = null
      this._hoverDelay = 150

      this._itemsWithChildren.forEach(item => this.handleSubmenu(item))

      this._topHeader.addEventListener('mouseleave', this._onTopHeaderLeave)
      this._topHeaderNav.addEventListener('mouseenter', this._clearCloseTimeout)
      this._topHeaderNav.addEventListener('mouseleave', () => {
        if (this._openContext) {
          this._scheduleClose(this._openContext.parent, this._openContext.submenu, this._openContext.next)
        }
      })

         // Infos rotator
      this._infoItems = document.querySelectorAll('.h-top-infos__item')
      this._infoIndex = 0
      if (this._infoItems.length > 1) {
        this.changeInfos()
      }
    }
  
    _clearCloseTimeout = () => {
      if (this._closeTimeout) {
        clearTimeout(this._closeTimeout)
        this._closeTimeout = null
      }
    }

    _scheduleClose = (parent, submenu, next) => {
      this._clearCloseTimeout()
      this._closeTimeout = setTimeout(() => {
        this._closeTimeout = null
        if (this._openContext && this._openContext.submenu === submenu) {
          this.close(parent, submenu, next)
        }
      }, this._hoverDelay)
    }

    _onTopHeaderLeave = () => {
      if (this._active && this._openContext) {
        this._scheduleClose(this._openContext.parent, this._openContext.submenu, this._openContext.next)
      }
    }

    handleSubmenu = (item) => {
      const link = item.querySelector(':scope > a, :scope > span')
      const submenu = item.querySelector(':scope > .sub-menu')
      if (!link || !submenu) return

      const parent = submenu.parentNode
      const next = submenu.nextSibling

      const open = () => {
        const current = this._topHeaderNav.querySelector(':scope > .sub-menu')
        if (current) current._back?.(true)

        submenu._back = (immediate) => this.close(parent, submenu, next, immediate)
        this._topHeaderNav.innerHTML = ''
        this._topHeaderNav.appendChild(submenu)
        this._topHeaderNav.removeAttribute('hidden')
        this._topHeaderNav.style.setProperty('--h-top-nav-height', `${this._topHeaderNav.scrollHeight}px`)
        this._topHeaderNav.classList.add('is-open')
        item.classList.add('is-open')
        this._active = item
        this._openContext = { parent, submenu, next }
      }

      item.addEventListener('mouseenter', () => {
        this._clearCloseTimeout()
        open()
      })

      item.addEventListener('mouseleave', () => {
        this._scheduleClose(parent, submenu, next)
      })
    }
  
    _doCloseCleanup = (parent, submenu, next) => {
      next ? parent.insertBefore(submenu, next) : parent.appendChild(submenu)
      this._topHeaderNav.innerHTML = ''
      this._topHeaderNav.setAttribute('hidden', '')
      this._active = null
      this._openContext = null
    }

    close = (parent, submenu, next, immediate = false) => {
      if (this._active) this._active.classList.remove('is-open')
      this._topHeaderNav.classList.remove('is-open')

      if (immediate) {
        this._doCloseCleanup(parent, submenu, next)
        return
      }

      const onTransitionEnd = (e) => {
        if (e.target !== this._topHeaderNav || e.propertyName !== 'max-height') return
        this._topHeaderNav.removeEventListener('transitionend', onTransitionEnd)
        this._doCloseCleanup(parent, submenu, next)
      }
      this._topHeaderNav.addEventListener('transitionend', onTransitionEnd)
    }

    changeInfos = () => {
        setInterval(() => {
          this._infoItems[this._infoIndex].setAttribute('hidden', '')
          this._infoIndex = (this._infoIndex + 1) % this._infoItems.length
          this._infoItems[this._infoIndex].removeAttribute('hidden')
        }, 5000)
      }
  }
  